console.log('✅ utils-debounce.js loaded successfully!'); // Debugging confirmation

export function debounce(fn, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

let debounceTimeout = null;

export function debounceShared(callback, delay = 500) {
  if (debounceTimeout) clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(callback, delay);
}
